import styled from 'styled-components'

export const SiderbarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: calc(100% - 50px);
  margin-top: 0px;

  .ant-menu-item a {
    color: #3a5a7d;
    font-weight: 600;
    font-size: 0.78rem;
  }

  .ant-menu-item-only-child {
    a {
      color: #000;
    }

    &:hover {
      a {
        color: #3a5a7d;
      }
    }
  }
`

export const NotiWrapper = styled.div`
  width: 460px;
  max-width: 90vw;
  background-color: #ffffff;
  border-radius: 12px;
  transition: all 0.3s;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.04);
  text-align: left;
  padding: 0;

  .ant-tabs-nav {
    margin: 0;
    padding: 6px 16px 0 16px;
    border-bottom: 1px solid #f0f0f0;
  }

  .ant-tabs-tab {
    padding: 8px 12px;
    font-size: 14px;
    color: #64748b;
    transition: color 0.2s;

    &.ant-tabs-tab-active .ant-tabs-tab-btn {
      color: #1890ff;
      font-weight: 600;
    }
  }

  .ant-tabs-ink-bar {
    background: #1890ff;
    height: 2px;
  }

  .noti-footer {
    padding: 12px 16px;
    text-align: center;
    border-top: 1px solid #f1f5f9;
    background-color: #ffffff;

    a,
    span[role='button'] {
      color: #1890ff;
      font-size: 14px;
      font-weight: 500;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      cursor: pointer;
      user-select: none;

      &:hover {
        color: #005a9e;
      }
    }
  }
`
